import { ReactComponent as Star } from '../assets/icons/star-solid.svg';

export const testimonials = [
	{
		id: 1,
		name: ' Ouided Gadhgadhi',
		country: 'Tunisia',
		opinion:
			"Working with this team was an absolute pleasure. Their attention to detail and commitment to excellence are unmatched. I'm thrilled with the results!",
		rate: [<Star />, <Star />, <Star />, <Star />, <Star />],
	},
	{
		id: 2,
		name: 'Aisha aal Mahjoub',
		country: 'United Arab Emirates',
		opinion:
			"An exceptional experience! The work was delivered on time, and the quality exceeded my expectations. Highly recommended!",
		rate: [<Star />, <Star />, <Star />, <Star />, <Star />],
	},
	{
		id: 3,
		name: 'Tom Dubois',
		country: 'Ireland',
		opinion:
			"Absolutely delighted with the service provided. Professional, efficient, and truly talented. I'll definitely be back for future projects.",
		rate: [<Star />, <Star />, <Star />, <Star />, <Star />],
	},
	{
		id: 4,
		name: 'Mourad Chebbi',
		country: 'Portugal',
		opinion:
			"I couldn’t be happier with the results. The team understood my requirements perfectly and delivered beyond what I imagined. Great job!",
		rate: [<Star />, <Star />, <Star />, <Star />, <Star />],
	},
];
